import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider, Stack, Typography, useTheme } from '@mui/material';
import { StatCard } from '../../../components/StatCard';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';
import QuestionMarkOutlinedIcon from '@mui/icons-material/QuestionMarkOutlined';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { useEffect, useState } from 'react';
import { useStudyContext } from '../../../context';
export const CardSection = () => {
    const theme = useTheme();
    const { studyResultData } = useStudyContext();
    const [averageAge, setAverageAge] = useState(0);
    const [genderRatio, setGenderRatio] = useState(0.5);
    const [intentRatio, setIntentRatio] = useState(0.5);
    const [averageRating, setAverageRating] = useState(0);
    const [categories, setCategories] = useState([]);
    const calculateAverageRating = () => {
        if (!(studyResultData === null || studyResultData === void 0 ? void 0 : studyResultData.result)) {
            return;
        }
        const ratings = studyResultData.result.panelMembers.map(m => m.creativeRating);
        const avg = ratings.reduce((sum, r) => sum + r, 0) / ratings.length;
        setAverageRating(Number.isFinite(avg) ? +avg.toFixed(2) : 0);
    };
    const calculateAverageAge = () => {
        if (!(studyResultData === null || studyResultData === void 0 ? void 0 : studyResultData.result)) {
            return;
        }
        const ages = studyResultData.result.panelMembers.map(m => m.age);
        const avgAge = ages.reduce((sum, age) => sum + age, 0) / ages.length;
        setAverageAge(Number.isFinite(avgAge) ? +avgAge.toFixed(0) : 0);
    };
    const calculateGenderRatio = () => {
        if (!(studyResultData === null || studyResultData === void 0 ? void 0 : studyResultData.result)) {
            return;
        }
        let male = 0;
        let female = 0;
        studyResultData.result.panelMembers.forEach(m => {
            if (m.gender.toLowerCase() === "male") {
                male += 1;
            }
            else {
                female += 1;
            }
        });
        setGenderRatio(male / (male + female));
    };
    const calculateIntentRatio = () => {
        if (!(studyResultData === null || studyResultData === void 0 ? void 0 : studyResultData.result)) {
            return;
        }
        let yes = 0;
        let no = 0;
        studyResultData.result.panelMembers.forEach(m => {
            if (m.intent) {
                yes += 1;
            }
            else {
                no += 1;
            }
        });
        setIntentRatio(yes / (yes + no));
    };
    const buildCategoriesArray = () => {
        if (!(studyResultData === null || studyResultData === void 0 ? void 0 : studyResultData.result)) {
            return;
        }
        setCategories(studyResultData.audiences);
    };
    useEffect(() => {
        if (!(studyResultData === null || studyResultData === void 0 ? void 0 : studyResultData.result)) {
            return;
        }
        calculateAverageRating();
        calculateAverageAge();
        calculateGenderRatio();
        calculateIntentRatio();
        buildCategoriesArray();
    }, [studyResultData]);
    return (_jsxs(Stack, { gap: "18px", flexWrap: "wrap", direction: "row", marginTop: "10px", children: [_jsx(StatCard, { title: "Average Age", icon: PermIdentityIcon, children: _jsx(Typography, { fontSize: "18px", fontWeight: 600, color: theme.palette.secondary.dark, children: averageAge }) }), _jsx(StatCard, { title: "Average Gender", icon: PeopleOutlinedIcon, children: _jsxs(Stack, { gap: "5px", direction: "row", height: "fit-content", alignItems: "center", children: [_jsx(Typography, { fontWeight: 700, fontSize: "12px", color: theme.palette.secondary.dark, children: (1 - genderRatio) * 100 + "% Women" }), _jsx(Divider, { orientation: "vertical", sx: {
                                backgroundColor: theme.palette.grey[300],
                                width: '1px',
                                height: '15px',
                            } }), _jsx(Typography, { fontSize: "12px", fontWeight: 700, color: theme.palette.secondary.dark, children: genderRatio * 100 + "% Men" })] }) }), _jsx(StatCard, { title: "Categories", icon: FormatListBulletedIcon, children: _jsx(Typography, { fontSize: "12px", fontWeight: 700, color: theme.palette.secondary.dark, children: categories.join(", ") }) }), _jsx(StatCard, { title: "Average Rating", icon: ThumbUpAltOutlinedIcon, children: _jsx(Typography, { fontSize: "12px", fontWeight: 700, color: theme.palette.secondary.dark, children: averageRating }) }), _jsx(StatCard, { title: "Intent Question", icon: QuestionMarkOutlinedIcon, children: _jsxs(Typography, { fontSize: "12px", fontWeight: 700, color: theme.palette.secondary.dark, children: [intentRatio * 100, " % Yes"] }) })] }));
};
